<template>
  <div class="edit_product">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="language('productDetails.tab1')" name="1">
        <el-form label-width="260px" class="demo-ruleForm">
          <el-form-item label="Merchant ID" prop="pass">
            <div>{{ tabData.shopNum }}</div>
          </el-form-item>
          <el-form-item label="Barcode/ISBN" prop="">
            <div>{{ tabData.mchProductId }}</div>
          </el-form-item>
          <el-form-item label="Article Master" prop="">
            <div>{{ tabData.productNum }}</div>
          </el-form-item>
          <el-form-item label="original Article Master" prop="" v-if="tabData.originalProductNum">
            <div>{{ tabData.originalProductNum }}</div>
          </el-form-item>
          <el-form-item label="Primary Type Code" prop="">
            <div>
              {{ type[tabData.type] ? type[tabData.type].label : tabData.type }}
            </div>
          </el-form-item>
        </el-form>
        <cc-form :config="tab1Config" v-model="tabData" ref="form1" labelWidth="260px" :rules="rules"
          size="medium"></cc-form>
      </el-tab-pane>

      <template v-if="tabData.type != 'H'">
        <el-tab-pane :label="language('productDetails.tab2')" name="2">
          <cc-form :config="tab2Config" v-model="tabData" ref="form2" labelWidth="260px" :rules="rules"
            size="medium"></cc-form></el-tab-pane>
      </template>

      <template v-else>
        <el-tab-pane :label="language('productDetails.tab6')" name="6">
          <cc-form :config="tab6Config" v-model="tabData" ref="form6" labelWidth="260px" :rules="rules"
            size="medium"></cc-form>
        </el-tab-pane>
      </template>

      <el-tab-pane :label="language('productDetails.tab3')" name="3">
        <cc-form :config="tab3Config" v-model="tabData" ref="form3" labelWidth="260px" :rules="rules"
          size="medium"></cc-form>
      </el-tab-pane>

      <el-tab-pane :label="language('productDetails.tab4')" name="4">
        <cc-form :config="tab4Config" v-model="tabData" ref="form4" labelWidth="260px" :rules="rules"
          size="medium"></cc-form></el-tab-pane>

      <div class="button_wrap">
        <el-button type="primary" class="btn" @click="save">{{
          language("productDetails.save")
        }}</el-button>
      </div>
    </el-tabs>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";
import imageList from "./imageList";
export default {
  props: {
    editData: Object,
  },
  data() {
    return {
      type: {
        H: {
          value: "H",
          label: "Non Book",
        },
        C: {
          value: "C",
          label: "(Book) Mainland/國版",
        },
        D: {
          value: "D",
          label: "(Book) HKG/港版",
        },
        E: {
          value: "E",
          label: "(Book) TWN/台版",
        },
        F: {
          value: "F",
          label: "(Book) Others/外文版",
        },
        A: {
          value: "A",
          label: "(Book)SUP/本版",
        },
        'DT000': {
          tagType: "success",
          text: "PRY.HK/小學教參",
        },
        "DT100": {
          tagType: "success",
          text: "SEC.HK/中學教參",
        },
        "DT200": {
          tagType: "success",
          text: "UNI.HK/大專教參",
        },
        'FT000': {
          tagType: "success",
          text: "PRY.F/外文小學教參",
        },
        "FT100": {
          tagType: "success",
          text: "SEC.F/外文中學教參",
        },
        'FT200': {
          tagType: "success",
          text: "UNI.F/外文大專教參",
        },
      },
      tabData: {},
      activeName: "1",
      tab1Config: {
        props: [
          // {
          //   required: true,
          //   label: "Merchant ID",
          //   name: "shopNum",
          //   type: "input",
          // },
          // {
          //   required: true,
          //   label: "Model / Product ID / SKU",
          //   name: "mchProductId",
          //   type: "input",
          // },
          // {
          //   required: false,
          //   label: "Barcode/ISBN",
          //   name: "barcode",
          //   type: "input",
          // },
          // {
          //   required: false,
          //   label: "Article Master",
          //   name: "productNum",
          //   type: "input",
          // },
          // {
          //   required: true,
          //   label: "Primary Type Code",
          //   name: "type",
          //   type: "select",
          //   disabled: true,
          //   options: [
          //     {
          //       value: "H",
          //       label: "Non Book",
          //     },
          //     {
          //       value: "C",
          //       label: "(Book) Mainland/國版",
          //     },
          //     {
          //       value: "D",
          //       label: "(Book) HKG/港版",
          //     },
          //     {
          //       value: "E",
          //       label: "(Book) TWN/台版",
          //     },
          //     {
          //       value: "F",
          //       label: "(Book) Others/外文版",
          //     },
          //     {
          //       value: "A",
          //       label: "(Book)SUP/本版",
          //     },
          //   ],
          // },
          {
            // required: true,
            label: "Primary Class Code",
            name: "categories",
            type: "input",
          },
          {
            required: true,
            label: "Product Cover",
            name: "cover",
            type: "uploadFileV2",
            fileType: "image",
            // uploaderConf: uploadUtils.configPublish,
            uploaderConf: uploadUtils.configPublishV2("/perm/sisProduct/"),
            fFormat: ["image/png", "image/jpeg"],
            // info: "比例為：3:1",
          },
          {
            required: false,
            label: "Product Image List",
            name: "imageList",
            type: "component",
            componentName: imageList,
          },
          {
            required: true,
            label: "Online Status",
            name: "saleStatus",
            type: "radio",
            options: [
              {
                val: "0",
                label: "Offline",
              },
              {
                val: "1",
                label: "Online",
              },
              {
                val: "2",
                label: "Invisible",
              },
            ],
          },
          {
            required: false,
            label: "Product Category Code",
            name: "shopCategories",
            type: "input",
            info: this.language("productDetails.shopcategoryTips"),
            // info: "門店分類，多個用','隔開",
          },
          {
            required: false,
            label: "Product Campaign Code",
            name: "shopCampaigns",
            type: "input",
          },
          {
            // required: true,
            label: "Brand (Chi)",
            name: "brand",
            type: "input",
          },
          {
            required: false,
            label: "Brand (Eng)",
            name: "brandEn",
            type: "input",
          },
          {
            // required: true,
            label: "Recommend Retail Price(HKD)",
            name: "recommendPrice",
            type: "number",
          },
          {
            // required: true,
            label: "Selling Price(HKD)",
            name: "salePrice",
            type: "number",
          },
          {
            // required: true,
            label: "Product Cost(HKD)",
            name: "productCost",
            type: "number",
          },
          {
            required: false,
            label: "Original Price",
            name: "listPrice",
            type: "input",
          },
          {
            required: false,
            label: "Original Price Currency",
            name: "originalPriceCurrency",
            type: "input",
          },
          {
            // required: true,
            label: "Product Name (Chi)",
            name: "name",
            type: "input",
          },
          {
            required: false,
            label: "Product Name (Eng)",
            name: "nameEn",
            type: "input",
          },
          {
            // required: true,
            label: "Product Short Name (Chi)",
            name: "shortName",
            type: "input",
          },
          {
            required: false,
            label: "Product Short Name (Eng)",
            name: "shortNameEn",
            type: "input",
          },
          {
            // required: true,
            label: "Short Description (Chi)",
            name: "summary",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Short Description (Eng)",
            name: "summaryEn",
            type: "textarea",
            rows: 10,
          },
          {
            // required: true,
            label: "Long Description (Chi)",
            name: "introduction",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Long Description (Eng)",
            name: "introductionEn",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Video Link (YouTube ID)",
            name: "videoLink",
            type: "input",
          },
          {
            required: false,
            label: "Video Link Text (Chi)",
            name: "videoLinkText",
            type: "input",
          },
          {
            required: false,
            label: "Video Link Text (Eng)",
            name: "videoLinkTextEn",
            type: "input",
          },
          {
            // required: true,
            label: "Delivery Method",
            name: "deliveryMethod",
            type: "radio",
            options: [
              {
                val: "1",
                label: "Shop+Courier",
              },
              {
                val: "2",
                label: "Shop",
              },
              {
                val: "3",
                label: "Courier",
              },
            ],
          },
          {
            required: false,
            label: "Goods Collection Mode",
            name: "collectionMode",
            type: "radio",
            options: [
              {
                val: "1",
                label: "Self Delivered to dedicated Warehouse",
              },
              {
                val: "2",
                label: "Collected from Merchant",
              },
              {
                val: "3",
                label: "Direct Deliver from Merchant to Customer",
              },
            ],
          },
          {
            required: false,
            label: "Invoice Remarks (Chi)",
            name: "invoiceRemark",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Invoice Remarks (Eng)",
            name: "invoiceRemarkEn",
            type: "textarea",
            rows: 10,
          },
          {
            // required: true,
            label: "Agent Type",
            name: "agentType",
            type: "radio",
            options: [
              {
                val: "1",
                label: "Agent/代理商",
              },
              {
                val: "2",
                label: "Sole Agent/獨家代理商",
              },
              {
                val: "3",
                label: "Distributor/經銷商",
              },
              {
                val: "4",
                label: "Sole Distributor/獨家經銷商",
              },
              {
                val: "5",
                label: "Others",
              },
            ],
          },
          {
            required: false,
            label: "Sales Territory",
            name: "saleTerritory",
            type: "radio",
            options: [
              {
                val: "1",
                label: "Online + Offline",
              },
              {
                val: "2",
                label: "Online Only",
              },
              {
                val: "3",
                label: "HK Only (Online + Offline)",
              },
              {
                val: "4",
                label: "HK Only (Online)",
              },
            ],
          },
          {
            required: false,
            label: "Quantity Limit by Order",
            name: "quantityLimitByOrder",
            type: "number",
          },
        ],
      },
      tab1Data: {},

      tab2Config: {
        props: [
          {
            // required: true,
            label: "Publisher",
            name: "publisher",
            type: "input",
          },
          {
            // required: true,
            label: "Publication Date",
            name: "pubDate",
            type: "date",
          },
          {
            required: false,
            label: "Reprint Date",
            name: "reprintDate",
            type: "date",
          },
          {
            // required: true,
            label: "Country of Publication",
            name: "countryOfPublication",
            type: "input",
          },
          {
            // required: true,
            label: "Author",
            name: "author",
            type: "input",
          },
          {
            required: false,
            label: "Editor",
            name: "editor",
            type: "input",
          },
          {
            required: false,
            label: "Translator",
            name: "translator",
            type: "input",
          },
          {
            // required: true,
            label: "Page",
            name: "page",
            type: "number",
          },
          {
            // required: true,
            label: "Language",
            name: "language",
            type: "radio",
            options: [
              {
                val: "TC",
                label: "繁體中文",
              },
              {
                val: "SC",
                label: "簡體中文",
              },
              {
                val: "EN",
                label: "英文",
              },
              {
                val: "JP",
                label: "日文",
              },
              {
                val: "KR",
                label: "韓文",
              },
              {
                val: "FR",
                label: "法文",
              },
              {
                val: "IT",
                label: "意文",
              },
              {
                val: "IT",
                label: "其他語言",
              },
            ],
          },
          {
            required: false,
            label: "Book Sizes",
            name: "bookSize",
            type: "input",
          },
          {
            required: false,
            label: "Binding",
            name: "binding",
            type: "input",
          },
          {
            // required: true,
            label: "Edition",
            name: "edition",
            type: "input",
          },
          {
            required: false,
            label: "Series (Chi)",
            name: "series",
            type: "input",
          },
          {
            required: false,
            label: "Seriers (Eng)",
            name: "seriesEn",
            type: "input",
          },
          {
            // required: true,
            label: "Content Abstract",
            name: "contentAbstract",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Table of Contents",
            name: "tableOfContents",
            type: "input",
          },
          {
            required: false,
            label: "Author Profile",
            name: "authorProfile",
            type: "textarea",
            rows: 10,
          },
        ],
      },
      tab2Data: {},

      tab6Config: {
        props: [
          {
            required: false,
            label: "Series",
            name: "seriesNonBook",
            type: "input",
          },
          {
            // required: true,
            label: "Place of Manufacturing",
            name: "placeOfManufacturing",
            type: "input",
          },
          {
            required: false,
            label: "Color Theme",
            name: "colorTheme",
            type: "input",
          },
          {
            required: false,
            label: "Color(Eng)",
            name: "colorEn",
            type: "input",
          },
          {
            required: false,
            label: "Color(Chi)",
            name: "color",
            type: "input",
          },
        ],
      },
      tab6Data: {},

      tab3Config: {
        props: [
          {
            // required: true,
            label: "Weight (Gram)",
            name: "weight",
            type: "number",
          },
          {
            // required: true,
            label: "Packing Length(CM)",
            name: "length",
            type: "number",
          },
          {
            // required: true,
            label: "Packing Depth(CM)",
            name: "depth",
            type: "number",
          },
          {
            // required: true,
            label: "Packing Height(CM)",
            name: "height",
            type: "number",
          },
          {
            required: false,
            label: "Packing Spec (Chi)",
            name: "packingSpec",
            type: "input",
          },
          {
            required: false,
            label: "Packing Spec (Eng)",
            name: "packingSpecEn",
            type: "input",
          },
          {
            required: false,
            label: "Delivery Details (Chi)",
            name: "deliveryDetails",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Delivery Details (Eng)",
            name: "deliveryDetailsEn",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Pickup Days",
            name: "pickupDays",
            type: "number",
          },
          {
            required: false,
            label: "Return Days",
            name: "returnDays",
            type: "number",
          },
          {
            required: false,
            label: "Product Ready Days",
            name: "productReadyDays",
            type: "number",
          },
          {
            required: false,
            label: "Delivery Completion Days",
            name: "deliveryCompletionDays",
            type: "number",
          },
        ],
      },
      tab3Data: {},

      tab4Config: {
        props: [
          {
            required: false,
            label: "Warranty Description(Chi)",
            name: "warrantyDescription",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Warranty Description(Eng)",
            name: "warrantyDescriptionEn",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Warranty Period ",
            name: "warrantyPeriod",
            type: "number",
          },
          {
            required: false,
            label: "Warranty Period (Unit)",
            name: "warrantyPeriodUnit",
            type: "radio",
            options: [
              {
                val: "D",
                label: "Days",
              },
              {
                val: "M",
                label: "Months",
              },
              {
                val: "Y",
                label: "Years",
              },
            ],
          },
          {
            required: false,
            label: "Warranty Supplier(Chi)",
            name: "warrantySupplier",
            type: "input",
          },
          {
            required: false,
            label: "Warranty Supplier(Eng)",
            name: "warrantySupplierEn",
            type: "input",
          },
          {
            required: false,
            label: "Supplier Email",
            name: "warrantySupplierEmail",
            type: "input",
          },
          {
            required: false,
            label: "Supplier Contact No.",
            name: "warrantySupplierContactNo",
            type: "input",
          },
          {
            required: false,
            label: "Supplier Address(Chi)",
            name: "warrantySupplierAddress",
            type: "input",
          },
          {
            required: false,
            label: "Supplier Address(Eng)",
            name: "warrantySupplierAddressEn",
            type: "input",
          },
        ],
      },
      tab4Data: {},

      rules: {
        shopNum: [
          {
            required: true,
            message: this.language("productDetails.shopNumTips"),
            trigger: "blur",
          },
        ],
        mchProductId: [
          {
            required: true,
            message: this.language("productDetails.machProductIDTips"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.language("productDetails.typeTips"),
            trigger: "blur",
          },
        ],
        categories: [
          {
            required: true,
            message: this.language("productDetails.categoryTips"),
            trigger: "blur",
          },
        ],
        saleStatus: [
          {
            required: true,
            message: this.language("productDetails.saleStatusTips"),
            trigger: "blur",
          },
        ],
        brand: [
          {
            required: true,
            message: this.language("productDetails.brandTips"),
            trigger: "blur",
          },
        ],
        recommendPrice: [
          {
            required: true,
            message: this.language("productDetails.recommendPriceTips"),
            trigger: "blur",
          },
        ],
        salePrice: [
          {
            required: true,
            message: this.language("productDetails.salePriceTips"),
            trigger: "blur",
          },
        ],
        productCost: [
          {
            required: true,
            message: this.language("productDetails.productCostTips"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.language("productDetails.nameTips"),
            trigger: "blur",
          },
        ],
        shortName: [
          {
            required: true,
            message: this.language("productDetails.shortNameTips"),
            trigger: "blur",
          },
        ],
        summary: [
          {
            required: true,
            message: this.language("productDetails.summaryTips"),
            trigger: "blur",
          },
        ],
        introduction: [
          {
            required: true,
            message: this.language("productDetails.introductionTips"),
            trigger: "blur",
          },
        ],
        deliveryMethod: [
          {
            required: true,
            message: this.language("productDetails.deliveryTips"),
            trigger: "blur",
          },
        ],
        agentType: [
          {
            required: true,
            message: this.language("productDetails.agentTypeTips"),
            trigger: "blur",
          },
        ],
        publisher: [
          {
            required: true,
            message: this.language("productDetails.publisherTips"),
            trigger: "blur",
          },
        ],
        pubDate: [
          {
            required: true,
            message: this.language("productDetails.pubDateTips"),
            trigger: "blur",
          },
        ],
        // reprintDate: [
        //   { required: true, message: "請輸入Reprint Date", trigger: "blur" },
        // ],
        countryOfPublication: [
          {
            required: true,
            message: this.language("productDetails.countryOfPublicationTips"),
            trigger: "blur",
          },
        ],
        // author: [
        //   {
        //     required: true,
        //     message: this.language("productDetails.authorTips"),
        //     trigger: "change",
        //   },
        // ],
        // editor: [{ required: true, message: "請輸入Editor", trigger: "blur" }],
        // translator: [
        //   { required: true, message: "請輸入Translator", trigger: "blur" },
        // ],
        // page: [
        //   {
        //     required: true,
        //     message: this.language("productDetails.pageTips"),
        //     trigger: "blur",
        //   },
        // ],
        language: [
          {
            required: true,
            message: this.language("productDetails.languageTips"),
            trigger: "blur",
          },
        ],
        edition: [
          {
            required: true,
            message: this.language("productDetails.editionTips"),
            trigger: "blur",
          },
        ],
        contentAbstract: [
          {
            required: true,
            message: this.language("productDetails.contentAbstractTips"),
            trigger: "blur",
          },
        ],
        placeOfManufacturing: [
          {
            required: true,
            message: this.language("productDetails.placeOfManufacturingTips"),
            trigger: "blur",
          },
        ],
        weight: [
          {
            required: true,
            message: this.language("productDetails.weightTips"),
            trigger: "blur",
          },
        ],
        length: [
          {
            required: true,
            message: this.language("productDetails.lengthTips"),
            trigger: "blur",
          },
        ],
        depth: [
          {
            required: true,
            message: this.language("productDetails.depthTips"),
            trigger: "blur",
          },
        ],
        height: [
          {
            required: true,
            message: this.language("productDetails.heightTips"),
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: this.language("productDetails.coverTips"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    save() {
      let result;
      if (this.tabData.type != "H") {
        result = Promise.all([
          this.chekeForm("form1"),
          this.chekeForm("form2"),
          this.chekeForm("form3"),
          this.chekeForm("form4"),
        ]);
      } else {
        result = Promise.all([
          this.chekeForm("form1"),
          this.chekeForm("form6"),
          this.chekeForm("form3"),
          this.chekeForm("form4"),
        ]);
      }

      //额外添加条件判断
      if (this.tabData.stockType == 1 && !this.tabData.extraDeliverDays && this.$shopData.isEscrow === 1) {
        this.$message.error(
          this.language("productDetails.extraDeliverDaysErrTips")
        );
        return;
      }

      result
        .then((res) => {
          let data = { ...this.tabData };
          if (data.listPrice) {
            data.listPrice = (data.listPrice * 1000) / 10;
          }
          if (data.recommendPrice) {
            data.recommendPrice = data.recommendPrice * 100;
          }
          if (data.salePrice) {
            data.salePrice = (data.salePrice * 1000) / 10;
          }
          if (data.productCost) {
            data.productCost = (data.productCost * 1000) / 10;
          }
          this.ccRequest
            .do("admin/merchant/product/save", data, "POSTJSON")
            .then((res) => {
              this.$alert("待「一本」批核", "提示", {
                confirmButtonText: "確認",
                callback: (action) => {
                  this.$message.success(
                    this.language("productDetails.success")
                  );
                  this.$emit("success", true);
                },
              });
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(this.language("common.mustNotEmpty"));
        });
    },
    chekeForm(refName) {
      return new Promise((resolve, reject) => {
        this.$refs[refName]
          .validate()
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
  mounted() {
    this.tabData = { ...this.editData };

    if (this.$shopData.isEscrow === 1) {
      this.tab1Config.props.splice(
        4,
        0,
        {
          required: false,
          label: "Storage Type",
          name: "stockType",
          type: "radio",
          options: [
            {
              val: 0,
              label: "Only-in-store",
            },
            {
              val: 1,
              label: "In/Out-store",
            },
          ],
        },
        {
          required: false,
          label: "Extra Delivery Time",
          name: "extraDeliverDays",
          type: "number",
          info: this.language("productDetails.extraDeliverDaysTips"),
        }
      );
    }

    // this.tab1Config.props[1] = {
    //   // required: true,
    //   label: "Product Cover",
    //   name: "cover",
    //   type: "uploadFileV2",
    //   fileType: "image",
    //   uploaderConf: uploadUtils.configPublishV2(
    //     "/perm/sisProduct/" + this.tabData.shopNum + "/"
    //   ),
    //   fFormat: ["image/png", "image/jpeg"],
    //   // info: "比例為：3:1",
    // };
  },
};
</script>
<style lang="scss">
.edit_product {
  .upload-btnV2 .upload-demo {
    margin-top: -19px !important;
  }
}
</style>